'use strict';

/**
 * Класс HTTP-транспорта агента.
 * Предоставляет инструменты для работы с Агентом веб-доступа через HTTP. Например, получить адрес Агент веб-доступа.
 *
 * @class HTTP
 * @extends global.agent.transport.BaseTransport
 * @since 5.1.0.1500
 */
(function (global) {

  /** Http порт агента по умолчанию. */
  const DEFAULT_AGENT_HTTP_PORT = 9554;

  /** Https порт агента по умолчанию. */
  const DEFAULT_AGENT_HTTPS_PORT = 9654;

  var HTTP = global.agentCore.transport.BaseTransport.extend({
    className: 'HTTP',
    name: 'HTTP',

    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    init: function () {
      this._super();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Запускает Агент веб-доступа по URI-схеме.
     * После запуска во всех браузерах, отличных от Internet Explorer, проверяется соединение с Агентом.
     * Если Агент не отвечает, он считается недоступным.
     *
     * @method HTTP#start
     * @override
     * @param {string} sessionId ID сессии пользователя.
     * @returns {Object} Отложенный (deferred) объект.
     * @since 5.1.0.1500
     */
    start: function (sessionId) {
      var me = this;
      me._super();

      return me._run(me._getSessionID(sessionId));
    },

    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Перезапускает Агент веб-доступа по URI-схеме.
     * После запуска во всех браузерах, отличных от Internet Explorer, проверяется соединение с Агентом.
     * Если Агент не отвечает, он считается недоступным.
     *
     * @method HTTP#restart
     * @override
     * @param {string} sessionId ID сессии пользователя.
     * @returns {Object} Отложенный (deferred) объект.
     * @since 5.1.0.1500
     */
    restart: function (sessionId) {
      var me = this;
      me._super();
      return me._run(me._getSessionID(sessionId), 'RESTART');
    },

    /**
     * Получает ИД сессии веб-доступа.
     *
     * @method HTTP#_getSessionID
     * @private
     * @param {string} sessionId ID сессии пользователя.
     * @returns {string} ИД сессии Агента веб-доступа.
     * @since 5.4.0.1011
     */
    _getSessionID: function (sessionId) {
      return sessionId || '';
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Запускает агента по URI схеме с параметром param
     *
     * @method HTTP#_run
     * @private
     * @param {string} sessionId ID сессии пользователя.
     * @param {string} param
     * @returns {Object} Отложенный (deferred) объект.
     */
    _run: function(sessionId, param) {
      this._super();
      global.agentCore.log.info('AGENT: Starting HTTP transport');

      if (param == null) {
        param = "START";
      }
      var uri = "waagent54:" + (param ? (param + '&' + sessionId) : sessionId);
      global.agentCore.log.info('AGEN: Launched URL Schema: ' + uri);

      if (this._isBrowserEqualTo('webkit') || this._isBrowserEqualTo('edge')) { // Бывали случаи, когда Edge не срабатывал на регулярку для webkit #23148
        this._startInWebKit(uri);
      } else {
        if (this._isBrowserEqualTo('firefox')) {
          this._startInFirefox(uri);
        } else {
          this._startDefault(uri);
        }
      }

      return this.waitForStart(sessionId);
    },

    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Останавливает работу Агента веб-доступа.
     *
     * @method HTTP#stop
     * @returns {AgentCore.transport.HTTP} Объект типа HTTP.
     * @since 5.1.0.1500
     */
    stop: function () {
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Получает адрес сервера Агента в зависимости от используемого протокола веб-доступа.
     *
     * @method HTTP.getAgentServerUrl
     * @returns {string} Адрес сервера Агента веб-доступа.
     * @since 5.1.0.1516
     */
    getAgentServerUrl: function () {
      const httpPort = localStorage.getItem('agentHttpPort');
      if (this.httpPort === DEFAULT_AGENT_HTTP_PORT && httpPort) {
        this.httpPort = httpPort;
        this.httpsPort = localStorage.getItem("agentHttpsPort");
      }
      // HACK: Edge не доверяет агенту по http, поэтому всегда используем https.
      if (window.location.protocol === 'https:' || this._isBrowserEqualTo('edge')) {
        return 'https://localhost:' + this.httpsPort;
      } else {
        return 'http://localhost:' + this.httpPort;
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

   /**
     * Восстановить порты агента по умолчанию.
     *
     * @method HTTP.resoreAgentServerUrl
     * @since 5.8.0.9021
     */
    restoreAgentServerUrl: function () {
      this.httpPort = DEFAULT_AGENT_HTTP_PORT;
      this.httpsPort = DEFAULT_AGENT_HTTPS_PORT;
      if (localStorage.getItem('agentHttpPort') !== null) {
        localStorage.removeItem('agentHttpPort');
        localStorage.removeItem('agentHttpsPort');
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


    /**
     * Обновить порты агента.
     *
     * @method HTTP.updateWorkingPorts
     * @param {string} httpPort Http порт агента.
     * @param {string} httpsPort Https порт агента.
     * @since 5.8.0.9021
     */
    updateWorkingPorts: function (httpPort, httpsPort) {
      localStorage.setItem('agentHttpPort', httpPort);
      localStorage.setItem('agentHttpsPort', httpsPort);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Оправка служебных асинхронных запросов агенту. Например, GetSessionRegistrationStatus.
     * Метод вынесен отдельно для возможности подмены его в тестах.
     *
     * @method HTTP._send
     * @private
     * @param {Object} params
     */
    _send: function(params) {
      var me = this;
      return $.ajax({
        timeout: 2000,
        type: 'GET',
        url: me.getAgentServerUrl(),
        data: params,
        cache: false
      });
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Отправляет запрос Агенту веб-доступа через HTTP-протокол (тип GET, заголовки CORS).
     * Сторона, отвечающая на запрос, должна отправить соответствующие заголовки запроса.
     * Если ответ на запрос не был получен, то вернется строка "CNA - connection not available".
     *
     * @method HTTP.call
     * @override
     * @param  {string} requestName Имя запроса
     * @param  {string} pluginName Имя плагина Агента, к которому идет обращение.
     * Для базовых вызовов к ядру Агента веб-доступа передается пустая строка
     * @param  {Object} params Параметры запроса
     * @param  {Object} ajaxParams Параметры ajax-запроса.
     * @returns {Deferred<Object>} Результат запроса.
     * @since 5.1.0.1500
     * @see https://api.jquery.com/category/deferred-object/
     */
    call: function(requestName, pluginName, params, ajaxParams) {
      var d = $.Deferred();

      var me = this;
      params.method = requestName;
      params.plugin = pluginName;

      var data = me._isContentTypeJson(ajaxParams) ? JSON.stringify(params) : params;
      var resultAjaxParams = $.extend({}, {
        type: 'GET',
        url: me.getAgentServerUrl(),
        async: true,
        cache: false,
        data: data
      }, ajaxParams);

      $.ajax(resultAjaxParams).done(function(res) {
        var respText = res;
        global.agentCore.log.debug('AGENT: "Call" method result: requestName: ' + requestName + ' response: ' + respText);
        d.resolve(respText);
      }).fail(function (err) {
        global.agentCore.log.error('AGENT: "Call" method error: requestName: ' + requestName + ' error: ' + JSON.stringify(err));
        d.reject('CNA');
      });

      return d.promise();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Открытие URI-схемы в Firefox
     * @method HTTP._startInFirefox
     * @private
     * @param {string} url
     * @since 5.1.0.1500
     */
    _startInFirefox: function(url) {
      // Создаем скрытый фрейм, в котором пытаемся открыть наш URL
      var frame = document.createElement('iframe');
      frame.style.display = 'none';
      frame = document.body.appendChild(frame);

      try {
        frame.contentWindow.location = url;
      } catch (e) {
      }
      // Удаляем наш временный фрейм
      document.body.removeChild(frame);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Открытие URI-схемы в Chrome, Safari
     * К сожалению в отличие от FF хром выводит окошко асинхронно и что там решилось
     * мы от браузера узнать не можем, и поэтому атакуем агента с надеждой на
     * ответ.
     * @method HTTP._startInWebKit
     * @private
     * @param {string} url
     * @since 5.1.0.1500
     */
    _startInWebKit: function(url) {
      // Если веб-доступ работает через HTTPS, то запрос из frame к waagent блокируются, поэтому меняем просто window.location.
      // Без setTimeout агент не всегда запускался по url-схеме в Chrome.
      setTimeout(function() {
        window.location = url;
      }, 100);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Открытие URI-схемы во всех остальных браузерах.
     * @method HTTP._startDefault
     * @private
     * @param {string} url
     * @since 5.1.0.1500
     */
    _startDefault: function(url) {
      // Создаем скрытый фрейм, в котором пытаемся открыть наш URL
      var frame = document.createElement('iframe');
      frame.style.display = 'none';
      frame = document.body.appendChild(frame);
      frame.contentWindow.location = url;
      setTimeout(function() {
        try {
          // Пытаемся поработать с не определенным атрибутом фрейма
          // (вместо something можно использовать что-угодно)
          if (frame.contentWindow.location != 'something') {
            $.noop();
          }
        } catch (e) {
        }

        // Удаляем наш временный фрейм
        document.body.removeChild(frame);
      }, 0);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Определяет, является ли браузер пользователя конретным браузером.
     *
     * @method HTTP#_isBrowserEqualTo
     * @private
     * @param  {string} browserName Назване браузера или семейства браузеров, которое сравнивается с браузером пользователя.
     * Может иметь следующие значения: edge, firefox, webkit.
     * @returns {boolean} True - если браузер пользователя совпадает с тем, который был передан в качетве параметра, иначе - False.
     * @since 5.6
     */
    _isBrowserEqualTo: function(browserName) {
      var ua = navigator.userAgent;
      switch (browserName) {
        case 'edge':
          if (/(edge)\/((\d+)?[\w\.]+)/i.test(ua)) return true;
          break;
        case 'firefox':
          if (/(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix)\/([\w\.-]+)/i.test(ua)) return true;
          break;
        case 'webkit':
          if (/(webkit|trident|netfront|netsurf|amaya|lynx|w3m)\/([\w\.]+)/i.test(ua)) return true;
      }
      return false;
    },

    _isContentTypeJson: function(ajaxParams) {
      return ajaxParams && ajaxParams.contentType && ajaxParams.contentType.includes('application/json');
    }
  });

  const http = new HTTP();
  http.restoreAgentServerUrl();
  global.agentCore.transport.HTTP = http;
  global.agentCore.transport.httpReady.resolve();

})(window);
